import * as React from 'react';
import { Button, Card, Icon } from 'semantic-ui-react';
import * as InfoCardApi from '~/Api/InfoCard';
import { Sentence } from '~/InfoCard/Sentence';
import { TagLink } from '~/InfoCard/Tag';
var Footer = function (_a) {
    var infoCard = _a.infoCard, InfoCardsLink = _a.InfoCardsLink;
    var yearMonthTag = infoCard.tags.find(function (tag) { return tag.type === InfoCardApi.TagType.yearMonth; });
    var sourceTag = infoCard.tags.find(function (tag) { return tag.type === InfoCardApi.TagType.source; });
    return (<Card.Content extra>
			{yearMonthTag !== undefined ? (<span className='left floated'>
					<TagLink InfoCardsLink={InfoCardsLink} tag={yearMonthTag}/>
				</span>) : null}

			{sourceTag !== undefined ? (<span className='right floated'>
					<TagLink InfoCardsLink={InfoCardsLink} tag={sourceTag}/>
				</span>) : null}
		</Card.Content>);
};
export var InfoCard = function (_a) {
    var infoCard = _a.infoCard, InfoCardLink = _a.InfoCardLink, InfoCardsLink = _a.InfoCardsLink, menu = _a.menu;
    return (<Card data-testid='infocard'>
		<Card.Content extra>
			<Card.Header data-testid='header'>
				{infoCard.title}
				{menu}
			</Card.Header>
			<Card.Description>
				{infoCard.tags.map(function (tag) {
            switch (tag.type) {
                case InfoCardApi.TagType.brand:
                case InfoCardApi.TagType.market:
                    return <TagLink InfoCardsLink={InfoCardsLink} key={tag.type} tag={tag}/>;
                default:
                    return null;
            }
        })}
			</Card.Description>
		</Card.Content>
		<Card.Content>
			{infoCard.sentences.map(function (sentence, i) { return (<Sentence key={i} sentence={sentence}/>); })}
		</Card.Content>

		<Footer infoCard={infoCard} InfoCardsLink={InfoCardsLink}/>

		<Button attached primary as={React.useCallback(function (props) { return (<InfoCardLink id={infoCard.id}>
						<a {...props}/>
					</InfoCardLink>); }, [InfoCardLink, infoCard.id])} data-testid='open-infocard'>
			Vidět více <Icon name='arrow right'/>
		</Button>
	</Card>);
};
